(ns motorsaif.web.core
  (:require
   [motorsaif.web.ajax :as ajax]
   [taoensso.encore :as encore]
   ;; [motorsaif.log :as log]
   [motorsaif.sente :as sente]
   [motorsaif.utils :as utils]
   [clojure.string :as str]
   ;; [reagent.dom.client :as rdc]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.web.layout :as layout]
   [motorsaif.web.online-state :as online-state]
   [motorsaif.web.pwa :as pwa]
   [motorsaif.web.admin-subs]
[clojure.string :as str]
   [re-frame.core :as rf]
   [reagent.dom :as rdom]
   [reitit.frontend.easy :as rfe]
   [motorsaif.web.events :as web-events]
   [motorsaif.shared.events :as events]
   [motorsaif.web.subs]
   [motorsaif.i18n :as i18n]))

(defn navigate! [match _]
  (rf/dispatch [:reitit/navigate match]))

(defn start-router! []
  (rfe/start! routes/router navigate!
              {:use-fragment false}))

;; -------------------------
;; Initialize app

(defonce *root (atom nil))
(defn ^:dev/after-load mount-components []
  (rf/clear-subscription-cache!)

  ;; Flickers, but works.
  #_(let [_ (when @*root (.unmount @*root))
          root (reset! *root (rdc/create-root (.getElementById js/document "app")))]
      (rdc/render root [layout/page]))

  ;; When requiring a component from another namespace and updating said component, does not update.
  #_(let [root (or @*root (reset! *root (rdc/create-root (.getElementById js/document "app"))))]
      (rdc/render root [layout/page]))

  ;; Old react 17, works fine without flickering.
  (rdom/render [layout/main] (.getElementById js/document "app")))

(defn browser-attributes []
  (-> []
      (cond->
          utils/is-pwa? (conj "pwa")
          (re-find #"iPhone|iPad" js/navigator.userAgent) (conj "ios")
          (re-find #"Android" js/navigator.userAgent) (conj "android")
          (re-find #"Chrome" js/navigator.userAgent) (conj "chrome")
          (re-find #"Android 14" js/navigator.userAgent) (conj "android-14")
          (re-find #"Samsung" js/navigator.userAgent) (conj "samsung")

          (re-find #"HuaweiBrowser/14" js/navigator.userAgent) (conj "huawei-14"))))

(defn get-stored-theme []
  (or (js/localStorage.getItem "theme") "theme-default-light"))

(defn get-stored-font-size []
  (or (js/localStorage.getItem "font-size") "medium"))

(defn set-classes []
  (let [browser-classes (str/trim (str/join (browser-attributes) " "))
        theme-class (get-stored-theme)
        font-size (get-stored-font-size)]
    ;; Add browser-specific classes
    (when-not (empty? browser-classes)
      (.add (.-classList js/document.documentElement) browser-classes))
    ;; Add theme class and store in app state
    (web-events/set-theme! theme-class)
    (rf/dispatch [:assoc-data [:current-theme] theme-class])
    ;; Set font size and store in app state
    (web-events/set-font-size! font-size)
    (rf/dispatch [:assoc-data [:current-font-size] font-size])))


;; (str (.-classList js/document.documentElement))
;; (.add (.-classList js/document.body) "show-overlay")

;; NOTE: ENV passing here is naive and does not elide dev code in prod builds.
;; TODO: Fix this later

(defn init! [env]
  (sente/init-socket! {:csrf-token (.-csrfToken js/window)})
  (sente/start-router!)

  (start-router!)

  (i18n/set-tr-fn! (rf/subscribe [:dict])
                   (rf/subscribe [:locale]))

  (rf/dispatch [:bootstrap-data])
  (rf/dispatch [:assoc-data [:env] env])

  ;; Ensure service worker is registered
  (events/ensure-after-bs #(pwa/ensure-sw))

  ;; Ensure we are correctly showing user that notifications are on
  (events/ensure-after-bs #(pwa/update-current-notification-state))

  (ajax/load-interceptors!)
  (mount-components)

  (online-state/init!)
  (set-classes))
